import NotificationsWidgetPopoverModule from './notifications-popover.module'

export default NotificationsWidgetPopoverModule
